export default "__VITE_ASSET___UeImeFF__"